// nativjs 功能
import { wgs84togcj02, gcj02tobd09 } from '@/business/utils/convertGps'
import { qqMapAppKey } from '@/business/views/Car/carQuery/AMap'
import { Toast } from 'vant'

export const ready = () => {
  return (typeof (plus) != 'undefined')&&(''!=plus&&null!=plus&&undefined!=plus)
}

// 判断终端
export const getSysType = () => {
  let obj = {
    'Android': '10504',
    'iOS': '10505',
    'H5':'10506', // h5终端
  }
  if (ready()) {
    return obj[plus.os.name]
  } else {
    return obj['H5']
  }
}

export const isH5 = () => {
  return (getSysType() == '10506')
}
export const isAndroid = () => {
  return (getSysType() == '10504')
}
export const isIOS = () => {
  return (getSysType() == '10505')
}

export const appVersion = () => {//app 版本
  if (ready()) {
    return plus.runtime.version
  }
  return '1.0'
}

export const getDeviceInfo = () => {// 获取设备信息
  if (ready()) {
    return {
      //Android - 2.2+ (支持): 返回字符串“Android”
      //iOS - 4.3+ (支持): 返回字符串“iOS”
      sysName:plus.os.name,
      //系统语言信息
      sysLanguage:plus.os.language,
      //系统的供应商信息 
      //Android - 2.2 + (支持): 返回字符串“Google”
      //iOS - 4.3+ (支持): 返回字符串“Apple”
      vendor:plus.os.vendor,
      //系统版本信息
      sysVersion:plus.os.version,
      //设备的型号 调用此属性获取设备的型号信息。 如果设备不支持则返回空字符串
      phoneModel:plus.device.model,
      //设备的生产厂商 调用此属性获取设备的生产厂商信息。 如果设备不支持则返回空字符串。
      companyVendor:plus.device.vendor,
      //设备的唯一标识 包括国际移动设备身份码、国际移动用户识别码、设备的唯一标识等信息。
      uuid: plus.device.getInfo,//方法
      // plus.device.getInfo({
      //     success:function(e){
      //         console.log('getDeviceInfo success: '+JSON.stringify(e));
      //     },
      //     fail:function(e){
      //         console.log('getDeviceInfo failed: '+JSON.stringify(e));
      //     }
      //     complete：function (e) { 
      //         console.log('getDeviceInfo failed: '+JSON.stringify(e));
      //    }
      // });
    }
  }
  return {}
}

export const Download = (url) => {
  if (!url) {
    return console.error(
      'The parameters passed in are not correct, the function does not work properly.'
    )
  }
  if(getSysType() == 10505){
    var dtask = plus.downloader.createDownload(url, {}, function(d, status){
      if(status == 200){ 
        Toast.fail({
          message: '下载成功',
        })
        plus.io.requestFileSystem( plus.io.PUBLIC_DOWNLOADS, function(){//fs
          // fs.root是根目录操作对象DirectoryEntry
          plus.openWindow({
            url:url,
            id: 'pdf',
            styles:{
              // additionalHttpHeaders: {
              //     referer:  global.address_url
              // },
              titleNView: {
                autoBackButton:false,
                buttons: [ //Array[ WebviewCustomButtonStyles ]类型,标题栏上的自定义按钮.建的自定义按钮数目不限制,实际应用中建议最多设置4个按钮(包括左侧返回按钮).
                  {
                    color: '', //String类型,按钮上文字颜色.可取值:"#RRGGBB"格式字符串,"rgba(R,G,B,A)".默认值为窗口标题栏控件的标题文字颜色.
                    colorPressed: '', //String类型,按下状态按钮文字颜色.String类型,按钮上文字颜色.可取值:"#RRGGBB"格式字符串,"rgba(R,G,B,A)".默认值为color属性值自动调整透明度为0.3.
                    float: 'right', //String类型,按钮在标题栏上的显示位置.right:在标题栏中靠右排列显示.left:在标题栏中靠左侧排列显示(在返回键后). 默认:right.
                    fontWeight: '', //String类型,按钮上文字的粗细.normal:标准字体.bold:加粗字体.默认:normal.
                    fontSize: '14px', //String类型,按钮上文字大小.可取值:字体高度像素值,数字加"px"格式字符串.
                    fontSrc: '', //String类型,按钮上文字使用的字体文件路径.相对路径:相对于当前页面的host位置,如"a.jpg",注意当前页面为网络地址则不支持.绝对路径:如Android平台"/sdcard/logo.png",此类路径通常通过其它5+ API获取的.扩展相对路径URL(RelativeURL):以"_"开头的相对路径,如"_www/a.jpg".本地路径URL:以"file://"开头,后面跟随系统绝对路径.
                    onclick: function(){
                      //var ws=plus.webview.currentWebview();
                      plus.webview.close('pdf')
                      //thst.goback();
                    }, //WebviewCustomButtonCallback类型,按钮点击后触发的回调函数.回调函数中将返回此JSON对象
                    text: '关闭' //String类型,按钮上显示的文字.推荐使用一个字符,超过一个字符可能无法正常显示,使用字体图标时unicode字符表示必须'\u'开头,如"\ue123"(注意不能写成"\e123").
                  }
                ],
                backButtonAutoControl: 'close'
              }
            },
            waiting: {
              autoShow: true, //自动显示等待框，默认为true
              title: '正在加载页面......', //等待对话框上显示的提示内容
            }
          })
              
        } )
      } else {
        Toast.fail({
          message: '下载失败',
        })
      }
    })
    dtask.start() 
    return
  }
  let a = document.createElement('a')
  a.href = url
  a.target = '_black'
  
  if (document.all) {
    a.click()
  } else {
    // 兼容 Firfox
    var evt = document.createEvent('MouseEvents')
    evt.initEvent('click', true, true)
    a.dispatchEvent(evt)
  }
}

// export const share = () => {
// 	if (ready()) {
// 		var shares = ''

// 		function cancelAuth (shares) {
// 			try {
// 				for ( var i in shares ) {
// 					var s = shares[i]
// 					if ( s.authenticated ) {
// 						plus.nativeUI.toast( '取消"'+s.description+'"')
// 					}
// 					s.forbid()
// 				}
// 				// 取消授权后需要更新服务列表
// 				//updateServices();
// 				plus.nativeUI.toast('操作成功！')
// 			} catch (e) {
// 				console.log(e)
// 			}
// 		}

// 		//发送分享
// 		function shareMessage(s,ex){
// 			//extra 可取值：“WXSceneSession”分享到微信的“我的好友”;“WXSceneTimeline”分享到微信的“朋友圈”中;“WXSceneFavorite”分享到微信的“我的收藏”中。默认值为“WXSceneSession” 。
// 			var msg={content:'庆华天下APP',extra:{scene:'WXSceneSession'}}
// 			var pic={}
// 			//pic.realUrl=mui('.share img')[0].src;
// 			//图片地址为本地地址
// 			pic.realUrl='./static/image/usercenter/orCode.png'
// 			if(pic&&pic.realUrl){
// 				msg.pictures=[pic.realUrl]
// 			}
// 			s.send( msg, function(){
// 				console.log( '分享到"'+s.description+'"成功！ ' )
// 			}, function(e){
// 				console.log( '分享到"'+s.description+'"失败: '+e.code+' - '+e.message )
// 			} )
// 		}

// 		//验证授权
// 		function shareAction(s, ex) {
// 			//outSet("分享操作：");
// 			if (!s) {
// 				plus.nativeUI.toast('无效的分享服务！')
// 				return
// 			}
// 			if (s.authenticated) {
// 				//common.tips("---已授权---");
// 				shareMessage(s, ex)
// 			} else {
// 				plus.nativeUI.toast('---未授权---')
// 				s.authorize(function() {
// 					shareMessage(s, ex)
// 				}, function(e) {
// 					plus.nativeUI.toast('认证授权失败：' + e.code + ' - ' + e.message)
// 				})
// 			}
// 		}

// 		plus.share.getServices(function(ss) {
// 			shares = ss
// 			//var list=document.getElementById('orCodelist');
// 			for (var i in ss ) {
// 				var s = ss[i]
// 				var item = document.createElement('li')
// 				item.setAttribute('class', 'ditem')
// 				item.setAttribute('onclick', (s.id == 'weixin') ? 'shareWeiXin(this.plusShare)' : 'shareAction(this.plusShare)')
// 				item.innerText = s.description
// 				item.plusShare = s
// 				//list.appendChild(item);
// 				if(s.id == 'weixin') {
// 					shareAction(ss[i])
// 				}
// 			}
// 		}, function(e) {
// 			plus.nativeUI.toast('获取分享服务列表失败：' + e.message)
// 		})
// 	}
// }

// 使用系统分享发送分享消息 
export const shareSystem = (params) => {
  if (ready()) {
    plus.share.sendWithSystem(Object.assign({ type: 'text', content: '分享内容', href: 'https://m.qhtxtrip.com/' },params), function () {
      console.log('分享成功')
      plus.nativeUI.toast('分享成功!')
    }, function (e) {
      plus.nativeUI.toast('分享失败：'+JSON.stringify(e))
      console.log('分享失败：' + JSON.stringify(e))
    })
  }
}


// 微信 判断安卓还是iOS
export function judgeClient() {
  let u = navigator.userAgent
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //判断是否是 android终端
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //判断是否是 iOS终端

  if (isAndroid) {
    return 'Android'
  } else if (isIOS) {
    return 'iOS'
  } else {
    return '其它'
  }
}

export function is_weixn(){
  var ua = navigator.userAgent.toLowerCase()
  if(ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

/**
 * h5 url跳转, APP内打开新webview窗口
 * 具体原生传参看 https://www.dcloud.io/docs/api/zh_cn/webview.html#plus.webview.open
 *  @url 可选 打开窗口加载的HTML页面地址 新打开Webview窗口要加载的HTML页面地址，可支持本地地址和网络地址
 *  @id 可选 打开窗口的标识窗口标识可用于在其它页面中通过getWebviewById来查找指定的窗口，为了保持窗口标识的唯一性，应该避免使用相同的标识来创建多个Webview窗口。 如果传入无效的字符串则使用url参数作为WebviewObject窗口的id值。
 *  @styles  ( WebviewStyles ) 可选 创建Webview窗口的样式（如窗口宽、高、位置等信息）
 *  @aniShow 可选 显示Webview窗口的动画效果 如果没有指定窗口动画，则使用默认无动画效果“none”。
 *  @duration 可选 显示Webview窗口动画的持续时间单位为ms，默认值为200ms（毫秒）。
 *  @showedCB 选 Webview窗口显示完成的回调函数 当指定Webview窗口显示动画执行完毕时触发回调函数，窗口无动画效果（如"none"动画效果）时也会触发此回调。
 */
export function openWebview (url, id, styles, aniShow = 'slide-in-right', duration, showedCB) {
  if (!url) {
    return console.error(
      'The parameters passed in are not correct, the function does not work properly.'
    )
  }
  
  styles = {
    titleNView: {
      titleText:'',
      autoBackButton: false,//(Boolean 类型 )标题栏控件是否显示左侧返回按钮
      buttons: [ //Array[ WebviewCustomButtonStyles ]类型,标题栏上的自定义按钮.建的自定义按钮数目不限制,实际应用中建议最多设置4个按钮(包括左侧返回按钮).
        {
          color: '', //String类型,按钮上文字颜色.可取值:"#RRGGBB"格式字符串,"rgba(R,G,B,A)".默认值为窗口标题栏控件的标题文字颜色.
          colorPressed: '', //String类型,按下状态按钮文字颜色.String类型,按钮上文字颜色.可取值:"#RRGGBB"格式字符串,"rgba(R,G,B,A)".默认值为color属性值自动调整透明度为0.3.
          float: 'right', //String类型,按钮在标题栏上的显示位置.right:在标题栏中靠右排列显示.left:在标题栏中靠左侧排列显示(在返回键后). 默认:right.
          fontWeight: '', //String类型,按钮上文字的粗细.normal:标准字体.bold:加粗字体.默认:normal.
          fontSize: '14px', //String类型,按钮上文字大小.可取值:字体高度像素值,数字加"px"格式字符串.
          fontSrc: '', //String类型,按钮上文字使用的字体文件路径.相对路径:相对于当前页面的host位置,如"a.jpg",注意当前页面为网络地址则不支持.绝对路径:如Android平台"/sdcard/logo.png",此类路径通常通过其它5+ API获取的.扩展相对路径URL(RelativeURL):以"_"开头的相对路径,如"_www/a.jpg".本地路径URL:以"file://"开头,后面跟随系统绝对路径.
          onclick: function () {
            //var ws=plus.webview.currentWebview();
            plus.webview.close(id)
          }, //WebviewCustomButtonCallback类型,按钮点击后触发的回调函数.回调函数中将返回此JSON对象
          text: '关闭' //String类型,按钮上显示的文字.推荐使用一个字符,超过一个字符可能无法正常显示,使用字体图标时unicode字符表示必须'\u'开头,如"\ue123"(注意不能写成"\e123").
        }
      ],
      backButtonAutoControl: 'close'//(String 类型 )Webview窗口自动处理返回键逻辑   "close" - 关闭Webview窗口，关闭动画与上一次调用显示时设置的动画类型相对应（如“slide-in-right”对应的关闭动画为“slid-out-right”） ； "none" - 不做操作，将返回键传递给下一Webview窗口处理； "quit" - 退出应用。
    }
  }

  if (getSysType() === '10506') {
    window.location.href = url
  } else {
    return plus.webview.open(url, id, styles, aniShow, duration, showedCB)
  }
}

/**
 * ios 获取定位
 * @param {String} type 优先使用的定位模块
 * 可取以下供应者： "system"：表示系统定位模块，支持wgs84坐标系； 
 *                 "baidu"：表示百度定位模块，支持gcj02/bd09/bd09ll坐标系； 
 *                 "amap"：表示高德定位模板，支持gcj02坐标系。 
 *                 默认值按以下优先顺序获取（amap>baidu>system），若指定的provider不存在或无效则返回错误回调。 
 *                 注意：百度/高德定位模块需要配置百度/高德地图相关参数才能正常使用。
 * @returns {Promise data: [Number, Number] | LngLat} GPS（wgs84）经纬度 例如: [116.23, 23.42]
 */
export function getIosPosition (provider = 'system') {
  return new Promise(async (resolve, reject) => {
    try {
      plus.geolocation.getCurrentPosition(function (point) {
        console.log('ios', point)
        const coords = point.coords || {}
        if (coords.longitude && coords.latitude) {
          resolve({
            LngLat: [coords.longitude, coords.latitude],
            coords: coords
          })
        } else {
          throw '定位失败！'
        }
      }, function (e) {
        switch (e.code) {
          case e.PERMISSION_DENIED:
            throw '您已拒绝获取定位，请开启定位重新获取！'
          case e.POSITION_UNAVAILABLE:
            throw '位置信息不可用！'
          case e.TIMEOUT:
            throw '获取位置信息请求超时！'
          case e.UNKNOWN_ERROR:
            throw '获取位置信息失败！'
        }
        switch (e.code) {
          case -1501:
            throw '坐标地址解析失败！'
          case -1502:
            throw '坐标地址获取失败！'
          case -1503:
            throw '定位权限获取失败！'
          case -1504:
            throw '坐标系类型不支持！'
          case -1505:
            throw '定位服务不能用！'
        }
      }, {
        provider
      })
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * 获取系统状态栏高度
 * 
 * @return height 
 * */ 
export function getStatusbarHeight () {
  try {
    // 获取是否为沉浸式状态栏模式
    var bi = plus.navigator.isImmersedStatusbar()
    if (bi) {
      //获取系统状态栏高度
      var lh = plus.navigator.getStatusbarHeight()
      console.log('获取系统状态栏高度: '+lh)
      // console.log('屏幕高度物理分辨率: '+plus.screen.height)
      // console.log('屏幕高度逻辑分辨率: '+plus.screen.resolutionHeight)
      // console.log('逻辑分辨率与物理分辨率的缩放比例: ' + plus.screen.scale)
      // var dpiX=plus.screen.dpiX
      // var dpiY = plus.screen.dpiY
      // var dpi = Math.sqrt(dpiX * dpiX + dpiY * dpiY)
      // console.log(dpiX,dpiY,dpi)
      // var px = lh * dpi / 72
      // console.log('px='+px)
      return Math.round(Math.round(lh))
    }
  } catch (error) {
    return 0
  }
}

/**
 * 设置系统状态栏样式
 * @param {String} type dark 黑色 light 白色
 * @return  
 * */ 
export function setStatusBarStyle (type) {
  // 设置系统状态栏样式为深色前景色样式
  plus.navigator.setStatusBarStyle(type)
  var ss = plus.navigator.getStatusBarStyle()
  // 获取系统状态栏背景
  var rgb = plus.navigator.getStatusBarBackground()
  console.log('获取系统状态栏样式: '+ss+'---获取系统状态栏背景：' + rgb)
}

// if(plus.navigator.hasNotchInScreen()){
//     console.log('此设备是刘海屏')
// }else{
//     console.log('此设备不是刘海屏')
// }
// // 是否全屏显示
// console.log(plus.navigator.isFullscreen()?'全屏状态!':'非全屏状态!')
// // 设置系统状态栏背景为红色
// plus.navigator.setStatusBarBackground('#FF0000')
        
// var h=plus.webview.getSecondWebview()
// if(h){
//     console.log('应用第二个首页Webview窗口：'+h.getURL())
// }else{
//     console.log('应用不存在第二个首页Webview窗口')
// }

// function onAppTrimMemory(){
//     console.log('清理内存!') 
// }
// document.addEventListener('trimmemory', onAppTrimMemory, false)

/**
 * 设置应用图标数字
 * @num String Number 数字
 */ 
export function setBadge(num) {
  plus.runtime.setBadgeNumber(num)
}

/**
 * 清除数字
 */ 
export function clearBadge() {
  plus.runtime.setBadgeNumber(0)
}

/**
 * APP中调用系统第三方程序进行导航
 * 百度 - bd09  高德 - wgs84  腾讯地图 - gcj02 苹果地图 - wgs84
 * @param {Point} startPoint 导航目的地坐标 格式 { lng, lat } - 需传入wgs84坐标系
 * @param {String} startName 导航出发地描述
 * @param {Point} stopPoint 导航起始地坐标 格式 { lng, lat } - 需传入wgs84坐标系
 * @param {String} stopName 导航目的地描述
 */
export function openSysMap(startPoint, startName, stopPoint, stopName) {
  // 如果还知道其他地图的包名，也可以放这个数组里
  let mapsPackageNames = [
      'com.baidu.BaiduMap',
      'com.autonavi.minimap',
      'com.tencent.map',
    ],
    appPackageName = 'com.lingdunakeji.h5',
    iosURLTypes = ['baidumap://', 'iosamap://', 'qqmap://']

  if (isIOS()) {
    mapsPackageNames = iosURLTypes
  }

  operationAfterCheckInstall(
    mapsPackageNames,
    function (res) {
      var m = 0, // 记录本机地图app个数
        gotoUrl = '', // 记录实际直接跳转地址
        btnArray = [], //实际显示按钮数组
        btnTitle = [
          '使用百度地图导航',
          '使用高德地图导航',
          '使用腾讯地图导航',
        ],
        urlArray = [] //实际显示跳转地址数组

      var wgs84_s_pos = [startPoint.lng, startPoint.lat],
        wgs84_d_pos = [stopPoint.lng, stopPoint.lat],
        gcj02_s_pos = wgs84togcj02(wgs84_s_pos[0], wgs84_s_pos[1]),
        gcj02_d_pos = wgs84togcj02(wgs84_d_pos[0], wgs84_d_pos[1]),
        bd09_s_pos = gcj02tobd09(gcj02_s_pos[0], gcj02_s_pos[1]),
        bd09_d_pos = gcj02tobd09(gcj02_d_pos[0], gcj02_d_pos[1])

        
      //百度api文档：http://lbsyun.baidu.com/index.php?title=uri/api/android
      //高德api文档：https://lbs.amap.com/api/amap-mobile/guide/ios/route
      //腾讯api文档：https://lbs.qq.com/webApi/uriV1/uriGuide/uriMobileRoute
      //苹果自带地图文档: https://developer.apple.com/library/archive/featuredarticles/iPhoneURLScheme_Reference/MapLinks/MapLinks.html
      var andrUrl = [
        `baidumap://map/direction?origin=name:${startName}|latlng:${bd09_s_pos[1]},${bd09_s_pos[0]}&destination=name:${stopName}|latlng:${bd09_d_pos[1]},${bd09_d_pos[0]}&src=${appPackageName}&coord_type=bd09ll`,
        `amapuri://route/plan/?sname=${startName}&slat=${wgs84_s_pos[1]}&slon=${wgs84_s_pos[0]}&dname=${stopName}&dlat=${wgs84_d_pos[1]}&dlon=${wgs84_d_pos[0]}&dev=0&t=0`,
        `qqmap://map/routeplan?type=drive&from=${startName}&fromcoord=${gcj02_s_pos[1]},${gcj02_s_pos[0]}&=to=${stopName}&tocoord=${gcj02_d_pos[1]},${gcj02_d_pos[0]}&referer=${qqMapAppKey}`,
      ]

      var iosUrl = [
        encodeURI(`baidumap://map/direction?origin=name:${startName}|latlng:${bd09_s_pos[1]},${bd09_s_pos[0]}&destination=name:${stopName}|latlng:${bd09_d_pos[1]},${bd09_d_pos[0]}&src=${appPackageName}&coord_type=bd09ll`),
        encodeURI(`iosamap://path?sourceApplication=applicationName&sid=&slat=${wgs84_s_pos[1]}&slon=${wgs84_s_pos[0]}&sname=${startName}&did=&dlat=${wgs84_d_pos[1]}&dlon=${wgs84_d_pos[0]}&dname=${stopName}&dev=0&t=0`),
        encodeURI(`qqmap://map/routeplan?type=drive&from=${startName}&fromcoord=${gcj02_s_pos[1]},${gcj02_s_pos[0]}&=to=${stopName}&tocoord=${gcj02_d_pos[1]},${gcj02_d_pos[0]}&referer=${qqMapAppKey}`),
      ]

      var appleMapUrl = encodeURI(`http://maps.apple.com/?saddr=${startName}&sll=${wgs84_s_pos[1]},${wgs84_s_pos[0]}&daddr=${stopName}&ll=${wgs84_d_pos[1]},${wgs84_d_pos[0]}&dirflg=d&t=m`)

      // 根据手机型号确定跳转数组var
      if (isIOS()) {
        urlArray = iosUrl
      } else {
        urlArray = andrUrl
      }

      var gotoUrlArr = []
      for (var k in res) {
        if (res[k]) {
          m++
          gotoUrl = urlArray[k]
          btnArray.push({
            title: btnTitle[k],
          })
          gotoUrlArr.push(urlArray[k])
        }
      }

      if (isIOS()) {
        m++
        btnArray.push({
          title: '使用苹果地图导航'
        })
        gotoUrlArr.push(appleMapUrl)
      }

      console.log(btnArray, gotoUrlArr)

      // 当只有一个地图APP时，直接跳转；不止一个时弹出原生选择框
      if (m > 1) {
        plus.nativeUI.actionSheet(
          {
            title: '请选择地图',
            cancel: '取消',
            buttons: btnArray,
          },
          function (e) {
            if (e.index > 0) {
              // 0:取消，1：百度，2：高德，3：腾讯 4: 苹果地图
              plus.runtime.openURL(gotoUrlArr[e.index - 1], e => {
                alert(e)
              })
            }
          }
        )
      } else {
        plus.runtime.openURL(gotoUrl, e => {
          alert(e)
        })
      }
    },
    function () {
      alert('您未安装百度地图、高德地图、腾讯地图,请前往应用市场下载')
    }
  )
}

//传入包名，检查手机上是否安装了这个应用
function isInstall(packageName){
  try {
    if(plus.os.name == 'iOS'){
      var UIApplication = plus.ios.importClass('UIApplication')  
      var NSURL = plus.ios.importClass('NSURL')  
          
      var app = UIApplication.sharedApplication()  
      var bdScheme = NSURL.URLWithString(packageName)  
      var install = app.canOpenURL(bdScheme)  
          
      plus.ios.deleteObject(bdScheme)  
      plus.ios.deleteObject(app)
      return install
    }else{
      var main = plus.android.runtimeMainActivity()
      var packageManager = main.getPackageManager()
      var PackageManager = plus.android.importClass(packageManager)
      var packageinfo = packageManager.getPackageInfo(packageName, PackageManager.GET_ACTIVITIES)
      if (packageinfo) {
        return true
      } else {
        return false
      }
    }
  } catch (e) {
    return false
  }
}

//批量传入包名，检查一系列应用是否安装，如果有任意一个安装了，就执行success，否认执行fai
function operationAfterCheckInstall (mapsPackageNames, success, fail){
  var res = mapsPackageNames.map(function(item) {
    return isInstall(item)
  })

  if (eval(res.join('||'))) {
    success(res)
  } else {
    fail()
  }
}


